import { render, staticRenderFns } from "./AssignMerchantModal.vue?vue&type=template&id=e0ade372&"
import script from "./AssignMerchantModal.vue?vue&type=script&lang=js&"
export * from "./AssignMerchantModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignMerchantModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports